<template>
  <div class="container-empty">
    <img src="img/icons_v2/icon-note.png" width="100px" height="100px" />
    <span>ยังไม่มีรายการ</span>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.container-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 40vh;
}

span {
  font-size: 27px;
  font-weight: 300;
  color: #a8a8a8;
}
</style>
